




























import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoIcon from '@/shared/components/respondeco-icon.vue'

@Component({
  components: { RespondecoIcon },
})
export default class HeroSearchField extends Vue {
  public value = ''

  public clear() {
    this.value = ''

    this.submit()
  }

  public submit() {
    this.$emit('submit', this.value)
  }
}
